module.exports = __webpack_public_path__ + "static/media/k-Kite.1126a25b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/k-Kite.png
// module id = 166
// module chunks = 0